export default {
  isFetchOrdersLoading: false,
  isFetchResultError: false,
  fetchOrderResult: false,
  isFetchOrderErrorMessage: '',
  fetchOrdersData: null
};
